]<template>
  <div>
    <b-container fluid class="px-0 pb-6 pb-8 pt-5 pt-md-6 bordes">
    <!-- Control the column width, and how they should appear on different devices -->
    <div class="row">
      <div class="col-sm-3 pt-5 text-center" style="background-color:#F5F5F5;">
        <div class="pt-1 pb-1 pl-1 pr-1 bg-white border">
          <div class="btn-group-vertical">
            <button @click="addCard(1)" type="button" class="btn btn-light">Proyecto</button>
            <button @click="addCard(2)" type="button" class="btn btn-light">Promotores</button>
            <button @click="addCard(3)" type="button" class="btn btn-light">Beneficiarios</button>
            <button @click="addCard(4)" type="button" class="btn btn-light">Responsabilidades</button>
            <button @click="addCard(5)" type="button" class="btn btn-light">Recursos</button>
            <button @click="addCard(6)" type="button" class="btn btn-light">Mec. de Dialogo</button>
            <button @click="addCard(7)" type="button" class="btn btn-light">Comp. Comunidad</button>
            <button @click="addCard(8)" type="button" class="btn btn-light">Rentabilidad Social</button>        
          </div>
        </div>
      </div>
      <div class="col-sm-9 pt-2" style="background-color:#F5F5F5;">      	
        <div class="table-responsive-sm font-weight-light">
          <table class="table text-center" style="cursor:pointer; background-color:#FFF;">
            <tr class="cellbackgr"><th colspan="2"><h3>Panel</h3></th></tr>                        
            <tr class="border-primary">
              <td colspan="2"><h3>Intervencion</h3>
                <draggable class="list-group list-group-horizontal-sm  bg-primary text-primary font-weight-bold" :list="list1" group="people" @change="log">
                  <div
                    @click="editModal('modal-proyecto', element)"
                    class="list-group-item list-group-item-action list-group-item-warning text-uppercase"
                    v-for="(element, index) in list1"
                    :key="element.titulo"
                  >
                    {{ element.titulo }} {{ index }}
                  </div>
                </draggable>  
                         
              </td>
            </tr>
            <tr class="headt">
              <td class="border-right"><h3>Promotores/Beneficios</h3>
                <draggable class="list-group list-group-horizontal-sm text-success font-weight-bold" :list="list2" group="people" @change="log">
                  <div
                    @click="editModal('modal-promotor', element)"
                    class="list-group-item list-group-item-action list-group-item-warning text-uppercase"
                    v-for="(element, index) in list2"
                    :key="element.name"
                  >
                    {{ element.name }} {{ index }}
                  </div>
                </draggable>
              </td>
              <td><h3>Beneficiarios/Beneficios</h3>
                <draggable class="list-group text-info font-weight-bold" :list="list3" group="people" @change="log">
                  <div
                    @click="editModal('modal-beneficiario', element)"
                    class="list-group-item"
                    v-for="(element, index) in list3"
                    :key="element.name"
                  >
                    {{ element.name }} {{ index }}
                  </div>
                </draggable>
              </td>
            </tr>
            <tr>
              <td colspan="2"><h3>Recursos</h3>
                <draggable class="list-group text-orange font-weight-bold" :list="list4" group="people" @change="log">
                  <div
                    @click="editModal('modal-recurso', element)"
                    class="list-group-item"
                    v-for="(element, index) in list4"
                    :key="element.name"
                  >
                    {{ element.name }} {{ index }}
                  </div>
                </draggable>
              </td>
            </tr>
            <tr>
              <td colspan="2"><h3>Actividades</h3>
                <draggable class="list-group text-purple font-weight-bold" :list="list5" group="people" @change="log">
                  <div
                    @click="editModal('modal-actividad', element)"
                    class="list-group-item"
                    v-for="(element, index) in list5"
                    :key="element.name"
                  >
                    {{ element.name }} {{ index }}
                  </div>
                </draggable>
              </td>
            </tr>
            <tr>
              <td colspan="2"><h3>Mecanismo Dialogo</h3>
                <draggable class="list-group text-olive font-weight-bold" :list="list6" group="people" @change="log">
                  <div
                    @click="editModal('modal-dialogo', element)"
                    class="list-group-item"
                    v-for="(element, index) in list6"
                    :key="element.name"
                  >
                    {{ element.name }} {{ index }}
                  </div>
                </draggable>
              </td>
            </tr>
            <tr>
              <td colspan="2"><h3>Compromiso con la Comunidad</h3>
                <draggable class="list-group text-yellow font-weight-bold" :list="list7" group="people" @change="log">
                  <div
                    @click="editModal('modal-responsabilidades', element)"
                    class="list-group-item"
                    v-for="(element, index) in list7"
                    :key="element.name"
                  >
                    {{ element.name }} {{ index }}
                  </div>
                </draggable>
              </td>
            </tr>
            <tr>
              <td colspan="2"><h3>Beneficios</h3>
                <draggable class="list-group text-danger font-weight-bold" :list="list8" group="people" @change="log">
                  <div
                    @click="editModal('modal-rentabilidad', element)"
                    class="list-group-item"
                    v-for="(element, index) in list8"
                    :key="element.name"
                  >
                    {{ element.name }} {{ index }}
                  </div>
                </draggable>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
</b-container>


    <!--<base-header class="px-0 pb-6 pb-8 pt-5 pt-md-6 bg-gradient-success">
      <div class="accordion" role="tablist">
        <b-card no-body class="mb-1">
          <b-card-header header-tag="header" class="p-1" role="tab">
            <h3 class="card-title"><b-button size="sm" v-b-toggle.accordion-1 variant="info"><i class="fa fa-filter"></i></b-button>Proyecto </h3>
            
          </b-card-header>
          <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
            <b-card-body>-->
<!---->

<!---->
       <!--     </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </base-header>-->

    <!--<b-container fluid class="mt--7">
      <b-row class="text-center">
        <b-col>

          <div class="row">
    <div class="col-3">
      <h3>Draggable 1</h3>
      <draggable class="list-group" :list="list1" group="people" @change="log">
        <div
          class="list-group-item"
          v-for="(element, index) in list1"
          :key="element.name"
        >
          {{ element.name }} {{ index }}
        </div>
      </draggable>
    </div>

    <div class="col-3">
      <h3>Draggable 2</h3>
      <draggable class="list-group" :list="list2" group="people" @change="log">
        <div
          class="list-group-item"
          v-for="(element, index) in list2"
          :key="element.name"
        >
          {{ element.name }} {{ index }}
        </div>
      </draggable>
    </div>

    <rawDisplayer class="col-3" :value="list1" title="List 1" />

    <rawDisplayer class="col-3" :value="list2" title="List 2" />
  </div>

        </b-col>
      </b-row>
      <div class="mt-5"></div>     
    </b-container>-->

    <!--Modal-->
    <b-modal
      id="modal-herr"
      ref="modal-herr"
      title="Herramienta SNF"
      @show="resetModal"
      @hidden="resetModal"
      @ok="handleOk"
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group
          label="Label"
          label-for="name-input"
        >
          <b-form-input
            id="name-input"
            v-model="name"
            :state="nameState"
            required
          ></b-form-input>
          <br>
          <p class="text-center"><b>Lorem Ipsum</b><br>
<small>"Neque porro quisquam est qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit..."
"There is no one who loves pain itself, who seeks after it and wants to have it, simply because it is pain..."</small></p>
        </b-form-group>
      </form>
    </b-modal>
    <!--End Modal-->


<!--Modals Buttons-->
    <!--Modal Proyecto-->
    <b-modal
      id="modal-prevent-closing"
      ref="modal-proyecto"
      title="Proyecto"
      @show="resetModal"
      @hidden="resetModal"      
    >
      <form ref="proyecto" @submit.stop.prevent="handleSubmitProyecto">
        <b-form-group
            id="nombre-proyecto"
            label-cols-sm="4"
            label-cols-lg="3"
            content-cols-sm
            content-cols-lg="7"
            description=""
            label="Nombre del"
            label-for="nombreProyecto"
            label-size="sm"
          >
            <b-form-input size="sm" id="nombreProyecto" v-model="proyecto.nombre"></b-form-input>
          </b-form-group>
          <b-form-group
            id="objetivo-proyecto"
            label-cols-sm="4"
            label-cols-lg="3"
            content-cols-sm
            content-cols-lg="7"
            description=""
            label="Objetivo"
            label-for="objetivoProyecto"
            label-size="sm"
          >
            <b-form-input size="sm" id="objetivoProyecto" v-model="proyecto.objetivo"></b-form-input>
          </b-form-group>
          <b-form-group
            id="componentes-proyecto"
            label-cols-sm="4"
            label-cols-lg="3"
            content-cols-sm
            content-cols-lg="7"
            description=""
            label="Componentes"
            label-for="componentesProyecto"
            label-size="sm"
          >
            <b-form-input size="sm" id="componentesProyecto" v-model="proyecto.componentes"></b-form-input>
          </b-form-group>
          <b-form-group
            id="monto-proyecto"
            label-cols-sm="4"
            label-cols-lg="3"
            content-cols-sm
            content-cols-lg="7"
            description=""
            label="Monto"
            label-for="montoProyecto"
            label-size="sm"
          >
            <b-form-input size="sm" type="number" step=".01" id="montoProyecto" v-model="proyecto.monto"></b-form-input>
          </b-form-group>
          <!---->                           
          <b-button @click="addPais()" class="float-right" variant="success" size="sm">Agregar</b-button>
          <br/><br/>
          <!--Tabla-->
          <table class="table table-striped table-sm">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Country</th>
                <th scope="col">Companies</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="itemc in proyecto.paises.items" :key="itemc.id">
                <th scope="row"><input type="checkbox" aria-label="Checkbox for following text input"></th>
                <td>{{ itemc.country }}</td>
                <td>{{ itemc.companies }}</td>
              </tr>
            </tbody>
          </table>          
          <!--Fin tabla-->
          <br/>
          <b-form-group
            id="desc-proyecto"
            label-cols-sm="4"
            label-cols-lg="3"
            content-cols-sm
            content-cols-lg="7"
            description=""
            label="Descripción"
            label-for="descripcion-proyecto"
            label-size="sm"
          >
            <b-form-input size="sm" id="descripcion-proyecto" v-model="proyecto.descripcion"></b-form-input>
          </b-form-group>
          <b-form-group
            id="coord-proyecto"
            label-cols-sm="4"
            label-cols-lg="3"
            content-cols-sm
            content-cols-lg="7"
            description=""
            label="Coordenadas"
            label-for="coordenadas-proyecto"
            label-size="sm"
          >
            <b-form-input size="sm" id="coordenadas-proyecto" v-model="proyecto.coordenadas"></b-form-input>
          </b-form-group>
      </form>
      <template #modal-footer>
        <div class="w-100">
          <b-row>
            <b-col>
              <b-button
                variant="primary"
                size="sm"
                class="float-left"
                @click="handleOk(1)"
              >
                Guardar
              </b-button>              
            </b-col>
            <b-col class="text-rigth">
              <b-button
                variant="danger"
                size="sm"
                class="float-right"
                @click="hideModal('modal-proyecto')"
              >
                Cerrar
              </b-button>              
            </b-col>
          </b-row>
        </div>
      </template>
    </b-modal>

    <!--Modal Promotor-->
    <b-modal
      id="modal-prevent-closing"
      ref="modal-promotor"
      title="Promotor"
      @show="resetModal"
      @hidden="resetModal"
    >
      <form ref="promotor" @submit.stop.prevent="handleSubmit">
        <b-container class="p-2">
          <b-form-group
            id="tipo-promotor"
            label-cols-sm="4"
            label-cols-lg="3"
            content-cols-sm
            content-cols-lg="7"
            description=""
            label="Tipo:"
            label-for="tipo"
            label-size="sm"
          >
            <b-form-select id="tipo" v-model="selTipoPromotor" :options="promotor.tipo" size="sm" class="mt-3"></b-form-select>
          </b-form-group>          
          <b-form-group
            id="actor-social"
            label-cols-sm="4"
            label-cols-lg="3"
            content-cols-sm
            content-cols-lg="7"
            description=""
            label="Actor Social"
            label-for="actsocial"
            label-size="sm"
          >
            <b-form-input size="sm" id="actsocial" v-model="promotor.actorSocial"></b-form-input>
          </b-form-group>
          
          <b-form-group
            id="desc1-promotor"
            label-cols-sm="4"
            label-cols-lg="3"
            content-cols-sm
            content-cols-lg="7"
            description=""
            label="Descripcion"
            label-for="desc-promotor"
            label-size="sm"
          >
            <b-form-textarea
              id="desc-promotor"
              v-model="promotor.descripcion"
              placeholder="..."
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </b-form-group>              

          <b-form-group
            id="impactos-promotor"
            label-cols-sm="4"
            label-cols-lg="3"
            content-cols-sm
            content-cols-lg="7"
            description=""
            label="Impactos"
            label-for="impactos-promotor"
            label-size="sm"
          >
            <b-form-checkbox-group
              id="impactos-promotor"
              v-model="selImpacProm"
              :options="promotor.impactos"
              name="flavour-1"
            ></b-form-checkbox-group>
          </b-form-group>
        </b-container>
      </form>
      <template #modal-footer>
        <div class="w-100">
          <b-row>
            <b-col>
              <b-button
                variant="primary"
                size="sm"
                class="float-left"
                @click="handleOk(2)"
              >
                Guardar
              </b-button>              
            </b-col>
            <b-col class="text-rigth">
              <b-button
                variant="danger"
                size="sm"
                class="float-right"
                @click="hideModal('modal-promotor')"
              >
                Cerrar
              </b-button>              
            </b-col>
          </b-row>
        </div>
      </template>
    </b-modal>    

    <!--Modal Beneficiario-->
    <b-modal
      id="modal-benef"
      ref="modal-beneficiario"
      title="Beneficiario"
      @show="resetModal"
      @hidden="resetModal"
    >
      <form ref="beneficiario" @submit.stop.prevent="handleSubmit">
        <b-container class="p-2">
         
          <b-form-group
            id="actor-social"
            label-cols-sm="4"
            label-cols-lg="3"
            content-cols-sm
            content-cols-lg="7"
            description=""
            label="Actor"
            label-for="actor-beneficiario"
            label-size="sm"
          >
            <b-form-input size="sm" id="actor-beneficiario" v-model="beneficiario.actor"></b-form-input>
          </b-form-group>
          <b-form-group
            id="comun-social"
            label-cols-sm="4"
            label-cols-lg="3"
            content-cols-sm
            content-cols-lg="7"
            description=""
            label="Comunidad"
            label-for="comunidad-beneficiario"
            label-size="sm"
          >
            <b-form-input size="sm" id="comunidad-beneficiario" v-model="beneficiario.comunidad"></b-form-input>
          </b-form-group>          
          <b-form-group
            id="desc1-beneficiario"
            label-cols-sm="4"
            label-cols-lg="3"
            content-cols-sm
            content-cols-lg="7"
            description=""
            label="Descripcion"
            label-for="desc-beneficiario"
            label-size="sm"
          >
            <b-form-textarea
              id="desc-beneficiario"
              v-model="beneficiario.descripcion"
              placeholder="..."
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group
            id="impac-beneficiario"
            label-cols-sm="4"
            label-cols-lg="3"
            content-cols-sm
            content-cols-lg="7"
            description=""
            label="Impacto:"
            label-for="impacto-beneficiario"
            label-size="sm"
          >
            <b-form-select id="impacto-beneficiario" v-model="selTipoImpacBenef" :options="beneficiario.impactos" size="sm" class="mt-3"></b-form-select>
          </b-form-group>
          <!---->                           
          <b-button class="float-right" variant="success" size="sm">Generar Matriz</b-button>
          <br/><br/>

        </b-container>
      </form>
      <template #modal-footer>
        <div class="w-100">
          <b-row>
            <b-col>
              <b-button
                variant="primary"
                size="sm"
                class="float-left"
                @click="handleOk(3)"
              >
                Guardar
              </b-button>              
            </b-col>
            <b-col class="text-rigth">
              <b-button
                variant="danger"
                size="sm"
                class="float-right"
                @click="hideModal('modal-beneficiario')"
              >
                Cerrar
              </b-button>              
            </b-col>
          </b-row>
        </div>
      </template>
    </b-modal>    

    <!--Modal Responsabilidades-->
    <b-modal
      id="modal-respon"
      ref="modal-responsabilidades"
      title="Responsabilidades"
      @show="resetModal"
      @hidden="resetModal"
    >
      <form ref="responsabilidades" @submit.stop.prevent="handleSubmit">
        <b-container class="p-2">
          <b-form-group
            id="prom-responsabilidades"
            label-cols-sm="4"
            label-cols-lg="3"
            content-cols-sm
            content-cols-lg="7"
            description=""
            label="Promotor:"
            label-for="promotor-responsabilidades"
            label-size="sm"
          >
            <b-form-select id="promotor-responsabilidades" v-model="selPromResponsabilidad" :options="responsabilidades.promotores" size="sm" class="mt-3"></b-form-select>
          </b-form-group>
          <b-form-group
            id="benef-responsabilidades"
            label-cols-sm="4"
            label-cols-lg="3"
            content-cols-sm
            content-cols-lg="7"
            description=""
            label="Beneficiarios:"
            label-for="beneficiario-responsabilidades"
            label-size="sm"
          >
            <b-form-select id="beneficiario-responsabilidades" v-model="selBenefResponsabilidad" :options="responsabilidades.beneficiarios" size="sm" class="mt-3"></b-form-select>
          </b-form-group>                 
          <b-form-group
            id="activ-responsabilidad"
            label-cols-sm="4"
            label-cols-lg="3"
            content-cols-sm
            content-cols-lg="7"
            description=""
            label="Actividades:"
            label-for="actividades-responsabilidades"
            label-size="sm"
          >
            <b-form-input size="sm" id="actividades-responsabilidades" v-model="responsabilidades.actividades"></b-form-input>
          </b-form-group>
          <b-form-group
            id="coment-responsabilidades"
            label-cols-sm="4"
            label-cols-lg="3"
            content-cols-sm
            content-cols-lg="7"
            description=""
            label="Comantarios"
            label-for="comentarios-responsabilidades"
            label-size="sm"
          >
            <b-form-input size="sm" id="comentarios-responsabilidades" v-model="responsabilidades.comentarios"></b-form-input>
          </b-form-group>
        </b-container>
      </form>
      <template #modal-footer>
        <div class="w-100">
          <b-row>
            <b-col>
              <b-button
                variant="primary"
                size="sm"
                class="float-left"
                @click="handleOk(4)"
              >
                Guardar
              </b-button>              
            </b-col>
            <b-col class="text-rigth">
              <b-button
                variant="danger"
                size="sm"
                class="float-right"
                @click="hideModal('modal-responsabilidades')"
              >
                Cerrar
              </b-button>              
            </b-col>
          </b-row>
        </div>
      </template>
    </b-modal>

    <!--Modal Recursos Sociales-->
    <b-modal
      id="modal-prevent-closing"
      ref="modal-recurso"
      title="Recursos Sociales"
      @show="resetModal"
      @hidden="resetModal"
    >
      <form ref="recurso" @submit.stop.prevent="handleSubmit">
        <h3>Componenete Proyecto </h3>
          <!--Tabla-->
          <table class="table table-striped table-sm">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Country</th>
                <th scope="col">Companies</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="itemc in recurso.componente.items" :key="itemc.id">
                <th scope="row"><input type="checkbox" aria-label="Checkbox for following text input"></th>
                <td>{{ itemc.country }}</td>
                <td>{{ itemc.companies }}</td>
              </tr>
            </tbody>
          </table>          
          <!--Fin tabla-->
          <h3>Agregar componentes beneficiarios </h3>
          <b-form-group
            id="componentes-recurso"
            label-cols-sm="4"
            label-cols-lg="3"
            content-cols-sm
            content-cols-lg="7"
            description=""
            label="Componentes"
            label-for="componentesrecurso"
            label-size="sm"
          >
            <b-form-input size="sm" id="componentesrecurso" v-model="recurso.componentes"></b-form-input>
          </b-form-group>
          <b-form-group
            id="monto-recurso"
            label-cols-sm="4"
            label-cols-lg="3"
            content-cols-sm
            content-cols-lg="7"
            description=""
            label="Monto"
            label-for="montorecurso"
            label-size="sm"
          >
            <b-form-input size="sm" type="number" step=".01" id="montorecurso" v-model="recurso.monto"></b-form-input>
          </b-form-group>
          <!---->                           
          <b-button @click="addPais()" class="float-right" variant="success" size="sm">Agregar</b-button>
          <br/><br/>
          <!--Tabla-->
          <table class="table table-striped table-sm">
            <thead>
              <tr>
                <th scope="col">#</th>
                <th scope="col">Country</th>
                <th scope="col">Companies</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="itemc in recurso.componente.items" :key="itemc.id">
                <th scope="row"><input type="checkbox" aria-label="Checkbox for following text input"></th>
                <td>{{ itemc.country }}</td>
                <td>{{ itemc.companies }}</td>
              </tr>
            </tbody>
          </table>          
          <!--Fin tabla-->
      </form>
      <template #modal-footer>
        <div class="w-100">
          <b-row>
            <b-col>
              <b-button
                variant="primary"
                size="sm"
                class="float-left"
                @click="handleOk(5)"
              >
                Guardar
              </b-button>              
            </b-col>
            <b-col class="text-rigth">
              <b-button
                variant="danger"
                size="sm"
                class="float-right"
                @click="hideModal('modal-recurso')"
              >
                Cerrar
              </b-button>              
            </b-col>
          </b-row>
        </div>
      </template>
    </b-modal>

    <!--Modal Mecanismo de dialogo-->
    <b-modal
      id="modal-dialog"
      ref="modal-dialogo"
      title="Mecanismo de Dialogo"
      @show="resetModal"
      @hidden="resetModal"
    >
      <form ref="dialogo" @submit.stop.prevent="handleSubmit">
        <b-container class="p-2">
         
          <b-form-group            
            v-slot="{ ariaDescribedby }"
          >
            <b-form-checkbox-group
              v-model="dialogo.selected"
              :options="dialogo.options"
              :aria-describedby="ariaDescribedby"
              name="flavour-2a"
              stacked
            ></b-form-checkbox-group>
          </b-form-group> 
          <br/>      
          <b-form-group
            id="comen-dialogo"
            label-cols-sm="4"
            label-cols-lg="3"
            content-cols-sm
            content-cols-lg="7"
            description=""
            label="Comentario"
            label-for="comentario-dialogo"
            label-size="sm"
          >
            <b-form-textarea
              id="comentario-dialogo"
              v-model="dialogo.comentario"
              placeholder="..."
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </b-form-group>

        </b-container>
      </form>
      <template #modal-footer>
        <div class="w-100">
          <b-row>
            <b-col>
              <b-button
                variant="primary"
                size="sm"
                class="float-left"
                @click="handleOk(6)"
              >
                Guardar
              </b-button>              
            </b-col>
            <b-col class="text-rigth">
              <b-button
                variant="danger"
                size="sm"
                class="float-right"
                @click="hideModal('modal-dialogo')"
              >
                Cerrar
              </b-button>              
            </b-col>
          </b-row>
        </div>
      </template>
    </b-modal> 

    <!--Modal Compromiso con la comunidad-->
    <b-modal
      id="modal-compro"
      ref="modal-compromiso"
      title="Compromiso con la comunidad"
      @show="resetModal"
      @hidden="resetModal"
    >
      <form ref="compromiso" @submit.stop.prevent="handleSubmit">
        <b-container class="p-2">
         
          <b-form-group            
            v-slot="{ ariaDescribedby }"
          >
            <b-form-checkbox-group
              v-model="compromiso.selected"
              :options="compromiso.options"
              :aria-describedby="ariaDescribedby"
              name="flavour-2a"
              stacked
            ></b-form-checkbox-group>
          </b-form-group> 
          <br/>      
          <b-form-group
            id="comen-compromiso"
            label-cols-sm="4"
            label-cols-lg="3"
            content-cols-sm
            content-cols-lg="7"
            description=""
            label="Comentario"
            label-for="comentario-compromiso"
            label-size="sm"
          >
            <b-form-textarea
              id="comentario-compromiso"
              v-model="compromiso.comentario"
              placeholder="..."
              rows="3"
              max-rows="6"
            ></b-form-textarea>
          </b-form-group>

        </b-container>
      </form>
      <template #modal-footer>
        <div class="w-100">
          <b-row>
            <b-col>
              <b-button
                variant="primary"
                size="sm"
                class="float-left"
                @click="handleOk(7)"
              >
                Guardar
              </b-button>              
            </b-col>
            <b-col class="text-rigth">
              <b-button
                variant="danger"
                size="sm"
                class="float-right"
                @click="hideModal('modal-compromiso')"
              >
                Cerrar
              </b-button>              
            </b-col>
          </b-row>
        </div>
      </template>
    </b-modal> 

    <!--Modal Rentabilidad Social-->
    <b-modal
      id="modal-social"
      ref="modal-rentabilidad"
      title="Rentabilidad Social"
      @show="resetModal"
      @hidden="resetModal"
    >
      <form ref="rentabilidad" @submit.stop.prevent="handleSubmit">
        <b-container class="p-2">             
          <b-form-group
            id="vAntesProy"
            label-cols-sm="4"
            label-cols-lg="3"
            content-cols-sm
            content-cols-lg="7"
            description=""
            label="Valor antes del Proyecto"
            label-for="vap-rentabilidad"
            label-size="sm"
          >
            <b-form-input
              id="vap-rentabilidad"
              v-model="rentabilidad.valorantesProyecto"
              placeholder="0"
            ></b-form-input>
          </b-form-group>

          <b-form-group
            id="vDespProy"
            label-cols-sm="4"
            label-cols-lg="3"
            content-cols-sm
            content-cols-lg="7"
            description=""
            label="Valor despues del Proyecto"
            label-for="vdp-rentabilidad"
            label-size="sm"
          >
            <b-form-input
              id="vdp-rentabilidad"
              v-model="rentabilidad.valordespuesProyecto"
              placeholder="0"
              @change="CalcularRentabilidad()"
            ></b-form-input>
          </b-form-group>
          
          <b-form-group
            id="dif"
            label-cols-sm="4"
            label-cols-lg="3"
            content-cols-sm
            content-cols-lg="7"
            description=""
            label="Deferencia"
            label-for="dif-rentabilidad"
            label-size="sm"
          >
            <b-form-input
              id="dif-rentabilidad"
              v-model="rentabilidad.diferencia"
              placeholder="0"
            ></b-form-input>
          </b-form-group>
          
          <b-form-group
            id="vatriucion"
            label-cols-sm="4"
            label-cols-lg="3"
            content-cols-sm
            content-cols-lg="7"
            description=""
            label="Atribución"
            label-for="atribucion-rentabilidad"
            label-size="sm"
          >
            <b-form-input
              id="atribucion-rentabilidad"
              v-model="rentabilidad.atribucion"
              placeholder="0"
            ></b-form-input>
          </b-form-group> 
          
          <b-form-group
            id="vtotal"
            label-cols-sm="4"
            label-cols-lg="3"
            content-cols-sm
            content-cols-lg="7"
            description=""
            label="Total"
            label-for="total-rentabilidad"
            label-size="sm"
          >
            <b-form-input
              id="total-rentabilidad"
              v-model="rentabilidad.total"
              placeholder="0"
            ></b-form-input>
          </b-form-group>          
          <b-button @click="CalcularRentabilidad()" class="float-right" variant="success" size="sm">CALCULO</b-button>
        </b-container>
      </form>
      <template #modal-footer>
        <div class="w-100">
          <b-row>
            <b-col>
              <b-button
                variant="primary"
                size="sm"
                class="float-left"
                @click="handleOk(8)"
              >
                Guardar
              </b-button>              
            </b-col>
            <b-col class="text-rigth">
              <b-button
                variant="danger"
                size="sm"
                class="float-right"
                @click="hideModal('modal-rentabilidad')"
              >
                Cerrar
              </b-button>              
            </b-col>
          </b-row>
        </div>
      </template>
    </b-modal> 



<!--End modals buttons-->
  </div>
</template>
<script>
import draggable from "vuedraggable";
  import { Dropdown, DropdownItem, DropdownMenu, Form, Table, TableColumn } from 'element-ui';

  export default {
    name: "two-lists",
    display: "Two Lists",
    order: 1,      
    components: {
      draggable,      
      [Dropdown.name]: Dropdown,
      [DropdownItem.name]: DropdownItem,
      [DropdownMenu.name]: DropdownMenu,
      [Table.name]: Table,
      [TableColumn.name]: TableColumn
    },  
    data() {
      return { 
        list1: [],
      list2: [],
      list3: [],
      list4: [],
      list5: [],
      list6: [],
      list7: [],
      list8: [],
      //Area Modals--------------
      //Proyecto
      proyecto: new Form({
        nombre:'',
        objetivo:'',
        componentes:'',
        monto:0.0,
        descripcion:'',
        coordenadas:'',
        paises:{ titulos:['action', 'country', 'companies'], 
                 items:[
                  { id:1, action:'', country: 'USA', companies: 'Apple Inc. Microsoft' },
                  { id:2, action:'', country: 'Swedenn', companies: 'Ikkea' },
                  { id:3, action:'', country: 'Finland', companies: 'Nokia' }
                ]
                }
      }),
      //promotor
      selTipoPromotor: null,
      selImpacProm:null,
      promotor: new Form({
        tipo:[
          { value: null, text: 'Seleccione' },
          { value: 'a', text: 'Tipo A' },
          { value: 'b', text: 'Tipo B' },],
        actorSocial:'',
        descripcion:'',
        impactos:[
          { text: 'Opcion 1', value: 'op1' },
          { text: 'Opcion 2', value: 'op2' },
          { text: 'Opcion 3', value: 'op3' },
          { text: 'Opcion 4', value: 'op4' }          
        ]
      }),
      //beneficiario
      selTipoImpacBenef:null,
      beneficiario: new Form({
        actor:'',
        comunidad:'',
        descripcion:'',
        impactos:[
          { value: null, text: 'Seleccione' },
          { value: 'a', text: 'Tipo A' },
          { value: 'b', text: 'Tipo B' },         
        ]
      }),
      //responsabilidad
      selPromResponsabilidad:null,
      selBenefResponsabilidad:null,
      responsabilidades: new Form({
        promotores:[
          { value: null, text: 'Seleccione' },
          { value: 'a', text: 'Tipo A' },
          { value: 'b', text: 'Tipo B' },         
        ],
        beneficiarios:[
          { value: null, text: 'Seleccione' },
          { value: 'a', text: 'Tipo A' },
          { value: 'b', text: 'Tipo B' },         
        ],                
        actividades:'',
        comentarios:'',
      }),
      //recurso
      recurso: new Form({
        componentes:'',
        monto:0.0,
        componente:{
          items:[
            {id:0, country: 'USA', companies:'Apple INC'},
            {id:1, country: 'Sweden', companies:'IKEA'},
            {id:2, country: 'Finland', companies:'Nokia'}
          ]
        }
      }),
      //dialogo
      dialogo: new Form({
        selected:[],
        comentario:'',
        options:[
          { text: 'Sin dialogo', value: 'Sin dialogo' },
          { text: 'Logistica (Mecanismo de reclamos EIA, etc.)', value: 'Logistica (Mecanismo de reclamos EIA, etc.)' },
          { text: 'Mesa de Dialogo', value: 'Mesa de Dialogo' },
          { text: 'Mesa de desarrollo', value: 'Mesa de desarrollo' },
          { text: 'Mesa Ejecutiva Territorial', value: 'Mesa Ejecutiva Territorial' }
        ]
      }),
      //compromiso
      compromiso: new Form({
        selected:[],
        comentario:'',
        options:[
          { text: 'Sin gestión hacia la comunidad', value: 'Sin gestión hacia la comunidad' },
          { text: 'La empresa gestiona todo', value: 'La empresa gestiona todo' },
          { text: 'Co-gestión (Empresa-Comunidad)', value: 'Co-gestión (Empresa-Comunidad)' },
          { text: 'Gestión de la comunidad', value: 'Gestión de la comunidad' },
        ]
      }),
      //Rentabilidad
      rentabilidad: new Form({
        valorantesProyecto:0.0,
        valordespuesProyecto:0.0,
        diferencia:0.0,
        atribucion:0.0,
        total:0.0
      }),                  
      //------------------
      cardActual:0,
      name: '',
      nameState: null,
      submittedNames: [],        
      editmode: false,
      filtroActivo:false,
      perPage:10,
      currentPage: 1,
      totalItemsRow:10,

      filtro: new Form({
        nroFactura: '',
        codigoCaja: '',
        nroDocumento: '',
        idTurno: '',
        tiendaId:'-1',
        formaPagoId:'-1',
        Caja: 0,
        fechaI: this.getDate(),
        fechaF: this.getDate(),
        monto: 0,
        idCaja: "0",
      })
      };
    },
    methods: {
      addCard: function(key) {
        this.editmode=false;
        this.cardActual= key;
        this.name = "TEST" + key.toString();

        switch (key) {
          case 1:
            this.showModal('modal-proyecto');
            break;
          case 2:
            this.showModal('modal-promotor');
          break;
          case 3:
            this.showModal('modal-beneficiario');
          break;
          case 4:
            this.showModal('modal-responsabilidades');
          break;
          case 5:
            this.showModal('modal-recurso');
          break;
          case 6:
            this.showModal('modal-dialogo');
          break;
          case 7:
            this.showModal('modal-compromiso');
          break;                                                                        
          case 8:
            this.showModal('modal-rentabilidad');
          break;        
          default:
              this.showModal("modal-herr");
            break;
        }


        
      },
      CalcularRentabilidad(){
        if(this.rentabilidad.valorantesProyecto > 0 && this.rentabilidad.valordespuesProyecto> 0){
            this.rentabilidad.diferencia = this.rentabilidad.valorantesProyecto - this.rentabilidad.valordespuesProyecto;
        }else{

        }
      },
      handleOk(key, formActual,bvModalEvent){

      if(!this.editmode){       
        switch (key) {
            case 1:
                this.list1.push({ titulo: this.proyecto.nombre, data: this.proyecto, id: this.list1.length+1 },);
                this.hideModal('modal-proyecto');
              break;

              case 2:
              this.list2.push({ name: "PROMOTOR -"+ this.name, id: this.list2.length+1 },);
              this.hideModal('modal-promotor');
              break;
              case 3:
              this.list3.push({ name: "BENEFICIARIO -"+ this.name, id: this.list3.length+1 },);
              this.hideModal('modal-beneficiario');
              break;
              case 4:
              this.list4.push({ name: "RESPONSABILIDAD -"+ this.name, id: this.list4.length+1 },);
              this.hideModal('modal-responsabilidades');
              break;
              case 5:
              this.list5.push({ name: "RECURSOS -"+ this.name, id: this.list5.length+1 },);
              this.hideModal('modal-recurso');
              break;
              case 6:
              this.list6.push({ name: "DIALOGO -"+ this.name, id: this.list6.length+1 },);
              this.hideModal('modal-dialogo');
              break;
              case 7:
              this.list7.push({ name: "COMUNIDAD -"+ this.name, id: this.list7.length+1 },);
              this.hideModal('modal-compromiso');
              break;
              case 8:
              this.list8.push({ name: "RESPONSABILIDAD SOCIAL -"+ this.name + this.list8.length+1, id: this.list8.length+1 },);
              this.hideModal('modal-rentabilidad');
              break;

            default:
              break;
          }
      }
        //bvModalEvent.preventDefault()
        // Trigger submit handler
        //this.handleSubmit()        
    },
    log: function(evt) {
      window.console.log(evt);
    },      
      //------------------------------------------
      async getResults(page = 1) {      
        await axios.get(this.$gate.getApiUrl()+'Contabilidad/reporte/formas/pago?page='+page+'&perPage='+this.perPage,{ params: this.filtro })
        .then(({ data }) => {
          this.lstFormaPago = data;
          this.totalItemsRow = data.totalrow;
        }).catch( e => {
            /* si el token es invalido o esta vencido */
            if (e.response.status == 401) {
               this.$gate.removeLogin();
               this.$router.push("/Login");             
            }
        });
      },
      checkFormValidity() {
        const valid = this.$refs.form.checkValidity()
        this.nameState = valid
        return valid
      },
      resetModal() {
        //this.name = ''
        //this.nameState = null
      },
      handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return
        }
        // Push the name to submitted names
        //this.submittedNames.push(this.name)
        // Hide the modal manually
        this.$nextTick(() => {
          this.$bvModal.hide('modal-herr')
        })
      },      
      showModal(modal, id){
        console.log(id)
        this.$refs[modal].show();
      },
      hideModal(modal){
        this.$refs[modal].hide();
      },
      editModal(modal, item){
        this.editmode = true;
        //this.form.reset();
        this.name = item.name;
        this.$refs[modal].show();
        //$('#addNew').modal('show');
        //this.form.fill(caja);
      },
      aplicarFiltro(){
        //if(this.$gate.isAdmin()){
          let loader = this.$loading.show({
            // Optional parameters
            container: this.fullPage ? null : this.$refs.formContainer,
            canCancel: true,
            loader: 'dots',
          });
          this.getResults();
          loader.hide();     
      },       
      resetFiltro(){
        this.filtro.reset();      
        this.filtroActivo = false;
        //this.loadUsuariosPos();
      },
      onFiltroChange(){
        this.filtroActivo = true;
        //this.onChangeSelectCajas();
      },
      async onChangeSelectCajas(){
        this.filtroActivo = true;
        await axios.get(this.$gate.getApiUrl()+"Caja/tienda/"+this.filtro.tiendaId).then(({ data }) => {this.cajas = data;/*this.getSelectTienda();*/ }); 
      },
      verDetalleFactura: async function(factura){
        this.facturaActual = factura;
        await axios.get(this.$gate.getApiUrl()+"CajaAdministrativa/DetalleFactura?CajaId="+factura.cajaId+"&Factura="+factura.numeroFactura+"&Fecha="+this.filtro.fechaI).then(({ data }) => {this.detalleDeFactura = data.data; });
        await axios.get(this.$gate.getApiUrl()+"CajaAdministrativa/DetalleCajeraTurno/"+factura.turnoId).then(({ data }) => {this.cajero = data.data; });
        this.$refs['modal-DetalleFactura'].show();        
      },
      verDetalleProducto(df){
        this.productoActual = df;
        this.$refs['modal-detalleProducto'].show();
      },
      getDate(){
        var currentDate = new Date();        
        return currentDate.getFullYear()+"-"+(currentDate.getMonth()<9?"0"+(currentDate.getMonth()+1):(currentDate.getMonth()+1))+"-"+(currentDate.getDate()<10?"0"+currentDate.getDate():currentDate.getDate());
      },
      getSelectTienda(){
        this.tiendas.forEach(element => {
          let data = {value:element.id, text:element.nombre};
          this.selectTienda.push(data);          
        });
      },      
      /*editModal(caja){
        this.editmode = true;
        this.form.reset();
        this.$refs['modal-1'].show();
        //$('#addNew').modal('show');
        this.form.fill(caja);
      },*/
      updateCaja(){
        console.log('Actualizar Data');
        this.hideModal();
      },
      getHora(){
        var currentDate = new Date();
        var hora = currentDate.getHours();
        var min = currentDate.getMinutes();
        //var seg = currentDate.getSeconds();
        return (hora<10?("0"+hora):hora)+":"+(min<10?("0"+min):min);
      },      
      calculardiferencia(hora_desde="12:00T12:00"){
        var hora_inicio = hora_desde.split("T")[1];
        hora_inicio = hora_inicio.slice(0, 5);
        //var hora_iniciop = hora_desde;
        var hora_final = this.getHora();

        if(hora_desde > hora_final){          
          hora_inicio = hora_final;
          hora_final = hora_desde;
        }        

        
        // Expresión regular para comprobar formato
        var formatohora = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
        
        // Si algún valor no tiene formato correcto sale
        if (!(hora_inicio.match(formatohora)
              && hora_final.match(formatohora))){
          return;
        }
        
        // Calcula los minutos de cada hora
        var minutos_inicio = hora_inicio.split(':')
          .reduce((p, c) => parseInt(p) * 60 + parseInt(c));
        var minutos_final = hora_final.split(':')
          .reduce((p, c) => parseInt(p) * 60 + parseInt(c));
        
        // Si la hora final es anterior a la hora inicial sale
        if (minutos_final < minutos_inicio) return;
        
        // Diferencia de minutos
        var diferencia = minutos_final - minutos_inicio;
        
        // Cálculo de horas y minutos de la diferencia
        var horas = Math.floor(diferencia / 60);
        var minutos = diferencia % 60;
        
        return horas + ':' + (minutos < 10 ? '0' : '') + minutos;  
      },
      zfill(number, width=6) {
          var numberOutput = Math.abs(number); /* Valor absoluto del número */
          var length = number.toString().length; /* Largo del número */ 
          var zero = "0"; /* String de cero */  
          
          if (width <= length) {
              if (number < 0) {
                  return ("-" + numberOutput.toString()); 
              } else {
                  return numberOutput.toString(); 
              }
          } else {
              if (number < 0) {
                  return ("-" + (zero.repeat(width - length)) + numberOutput.toString()); 
              } else {
                  return ((zero.repeat(width - length)) + numberOutput.toString()); 
              }
          }
      },
      loadFacturas(){  
        this.getResults();
        axios.get(this.$gate.getApiUrl()+"Tienda").then(({ data }) => {this.tiendas = data; this.getSelectTienda(); });
        axios.get(this.$gate.getApiUrl()+"FormaPago").then(({ data }) => {this.formasPago = data; });
        
        //if(this.$gate.isAdminOrAuthor()){
        //axios.get(this.$gate.getApiUrl()+"CajaAdministrativa/ListadoFactura?Fecha="+this.filter.fecha+"&Turno="+this.filter.turno+"&Caja="+this.filter.codigoCaja).then(({ data }) => {this.facturas = data.data; });
          
        //}
      },

    },
    computed: {
      totalGeneralBs: function(){

        let total = [];

        Object.entries(this.detalleDeFactura.detalleFactura).forEach(([key, val]) => {
            total.push(parseInt(val.precioBolivar) * parseInt(val.cantidad)) // the value of the current key.
        });

        return total.reduce(function(total, num){ return total + num }, 0);

      },
      totalGeneralDolar: function(){

        let total = [];

        Object.entries(this.detalleDeFactura).forEach(([key, val]) => {
            total.push(parseInt(val.precioDolar)) // the value of the current key.
        });

        return total.reduce(function(total, num){ return total + num }, 0);

      },
      promedioTasaDolar: function(){
        var sumatoriaObjeto = this.facturas.reduce(function(acumulador, siguienteValor){
          return {
            tasa: acumulador.tasa + siguienteValor.tasa
          };
        }, {tasa: 0}); //Si no hay nada, regresamos un objeto con edad = 0. No hay necesidad de devolver el nombre, pues no es necesario

        return sumatoriaObjeto.tasa / this.facturas.length;
      },
    },    
    created(){
      //this.loadFacturas();
    }
  };
</script>
<style>
  .headt td {
    min-width: 235px;
    height: 100px;
  }
  .bordes{
    border-radius: 15px;
  }
  .cellbackgr{
    background: #C0C0C0;
  }
 .statscard{
   font-size: 13px;
 }
 .fondotasa{
   background: #f5f5f5;   
   font-weight: bold;
 } 
 .detallefactura {
    font-size: 0.8125rem;
    white-space: nowrap;
 }
 .bckgmontobs{
   background: #e2e6e7;
   font-weight: bold;
 }
 .ocultar{
   display: none;
 } 
</style>
